import React, { useState } from "react";
import PracticeSetupV2 from "@/components/practice-setup/PracticeSetupV2";
import ManageUsers from "@/components/settings/ManageUsers";
import PageShell from "@/components/PageShell";
import { useProfile } from "@/components/practice-setup/psPrimitives";

export default function Settings() {
  const { data: profile } = useProfile();
  const canManage = !!profile?.can_manage_logins;
  // Follow the URL until the user explicitly picks a tab. Derive `active` every
  // render so a cold-load deep link (?tab=users) still opens once the profile
  // query resolves and canManage flips true.
  const [picked, setPicked] = useState(null);
  const urlTab = new URLSearchParams(window.location.search).get("tab");
  const wanted = picked ?? (urlTab === "users" ? "users" : "setup");
  const active = wanted === "users" && canManage ? "users" : "setup";

  const go = (t) => {
    setPicked(t);
    const url = new URL(window.location.href);
    if (t === "users") url.searchParams.set("tab", "users"); else url.searchParams.delete("tab");
    window.history.replaceState({}, "", url.toString());
  };

  return (
    <PageShell variant="capped" data-testid="settings-view" className="fade-up">
      {canManage ? (
        <div className="flex items-center gap-1 mb-5 border-b border-[#E9E9EC]" data-testid="settings-tabs" role="tablist">
          {[{ k: "setup", label: "Practice Setup" }, { k: "users", label: "Manage Users" }].map((t) => (
            <button key={t.k} role="tab" aria-selected={active === t.k} onClick={() => go(t.k)} data-testid={`settings-tab-${t.k}`}
              className={`relative text-[13.5px] font-semibold px-4 py-2.5 transition ${active === t.k ? "text-[var(--ink)]" : "text-[var(--gray2)] hover:text-[var(--ink)]"}`}>
              {t.label}
              {active === t.k ? <span className="absolute left-3 right-3 -bottom-px h-[2px] rounded-full" style={{ background: "var(--ink)" }} /> : null}
            </button>
          ))}
        </div>
      ) : null}

      {active === "users" ? <ManageUsers profile={profile} /> : <PracticeSetupV2 />}
    </PageShell>
  );
}
